module.exports = __webpack_public_path__ + "img/budi.696b20a8.png";